import { disableScroll, enableScroll } from "./scroll-lock";

const activeElementsByOverlay = new WeakMap();
const pendingFramesByOverlay = new WeakMap();

// TODO: NTH pri zobrazeni a skryti transition pekny (podla vue, tam tie transition el)
function baseShow(activeElement, overlay, allowScroll) {
    if (!overlay) {
        return;
    }

    // Lock scroll immediately before RAF to capture correct position
    if (!allowScroll) {
        disableScroll(activeElement);
    }

    activeElementsByOverlay.set(overlay, activeElement);

    cancelAnimationFrame(pendingFramesByOverlay.get(overlay));
    pendingFramesByOverlay.set(
        overlay,
        requestAnimationFrame(() => {
            pendingFramesByOverlay.delete(overlay);
            overlay.classList.add("is-active");
        })
    );
}

function baseHide(activeElement, overlay) {
    if (!overlay || activeElement !== activeElementsByOverlay.get(overlay)) {
        return;
    }

    cancelAnimationFrame(pendingFramesByOverlay.get(overlay));
    pendingFramesByOverlay.delete(overlay);

    overlay.classList.remove("is-active");

    if (document.body.classList.contains("is-overlayed")) {
        enableScroll(activeElement);
    }

    activeElementsByOverlay.delete(overlay);
}

function showOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector(".js-overlay"), allowScroll);
}

function hideOverlay(activeElement) {
    baseHide(activeElement, document.querySelector(".js-overlay"));
}

function showHeaderOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, document.querySelector(".js-header-overlay"), allowScroll);
}

function hideHeaderOverlay(activeElement) {
    baseHide(activeElement, document.querySelector(".js-header-overlay"));
}

export { showOverlay, hideOverlay, showHeaderOverlay, hideHeaderOverlay };
